import { MIcon } from '../../components/@material-extend';

const ICON_SIZE = { width: 20, height: 20 };

export default function TreeView(theme) {
  return {
    MuiTreeView: {
      defaultProps: {
        defaultCollapseIcon: <MIcon icon="minus" {...ICON_SIZE} />,
        defaultExpandIcon: <MIcon icon="add_box" {...ICON_SIZE} />,
        defaultEndIcon: <MIcon icon="disabled_by_default" {...ICON_SIZE} color="text.secondary" />
      }
    },
    MuiTreeItem: {
      styleOverrides: {
        label: { ...theme.typography.body2 },
        iconContainer: { width: 'auto' }
      }
    }
  };
}
